import { BehaviorSubject } from 'rxjs';
import { fragQuery } from '@models';

export class SnapshotManager {
  private readonly _index$ = new BehaviorSubject<number>(0);
  private readonly _intervals$ = new BehaviorSubject<fragQuery.timeline.sieveSizesAtPercents.Interval[]>([]);
  private readonly _currentInterval$ = new BehaviorSubject<fragQuery.timeline.sieveSizesAtPercents.Interval | null>(null);
  private readonly _loading$ = new BehaviorSubject<boolean>(false);

  public get currentIndex$() {
    return this._index$.asObservable();
  }

  public get intervals$() {
    return this._intervals$.asObservable();
  }

  public get currentInterval$() {
    return this._currentInterval$.asObservable();
  }

  /** Getters */
  public get currentIndex(): number {
    return this._index$.value;
  }

  public get intervals(): fragQuery.timeline.sieveSizesAtPercents.Interval[] {
    return this._intervals$.value;
  }

  public get currentInterval(): fragQuery.timeline.sieveSizesAtPercents.Interval | null {
    return this._currentInterval$.value;
  }

  public get loading$() {
  return this._loading$.asObservable();
}

  /** Setters */
  public setIndex(index: number): void {
    const safeIndex = index >= 0 && index < this.intervals.length ? index : 0;
    this._index$.next(safeIndex);
    this._currentInterval$.next(this.intervals[safeIndex] ?? null);
  }

  public setIntervals(intervals: fragQuery.timeline.sieveSizesAtPercents.Interval[]): void {
    this._intervals$.next(intervals);
    // Update current interval based on current index
    const currentIdx = this._index$.value;
    this._currentInterval$.next(intervals[currentIdx] ?? null);
    this._loading$.next(false)
  }

  public setIntervalById(intervalId: number): void {
    const idx = this.intervals.findIndex(i => i.id === intervalId);
    if (idx >= 0) {
      this.setIndex(idx);
    } else {
      console.warn(`Interval with ID ${intervalId} not found`);
    }
  }

  public setLoading(value: boolean): void {
  this._loading$.next(value);
}

  /** Navigation */
  public next(): void {
    const max = this.intervals.length;
    const nextIndex = (this._index$.value + 1) % max;
    this.setIndex(nextIndex);
  }

  public previous(): void {
    const max = this.intervals.length;
    const prevIndex = (this._index$.value - 1 + max) % max;
    this.setIndex(prevIndex);
  }

}

export const snapshotManager = new SnapshotManager();
